// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

tag[type="for-related-image"] div {
	background-color: rgb(189, 209, 134) !important;
}

tag[type="page-number"] div {
	background-color: rgb(134, 209, 184) !important;
}

tag[type="person"] div {
	background-color: rgb(134, 209, 184) !important;
}

tag[type="place"] div {
	background-color: rgb(65, 177, 93) !important;
}

tag[type="theme"] div {
	background-color: rgb(209, 189, 134) !important;
}

tag[source="auto-ai"] i {
	color: rgb(255, 255, 0);
}
`, "",{"version":3,"sources":["webpack://./src/components/tags/style.css"],"names":[],"mappings":";;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":["\r\n\r\ntag[type=\"for-related-image\"] div {\r\n\tbackground-color: rgb(189, 209, 134) !important;\r\n}\r\n\r\ntag[type=\"page-number\"] div {\r\n\tbackground-color: rgb(134, 209, 184) !important;\r\n}\r\n\r\ntag[type=\"person\"] div {\r\n\tbackground-color: rgb(134, 209, 184) !important;\r\n}\r\n\r\ntag[type=\"place\"] div {\r\n\tbackground-color: rgb(65, 177, 93) !important;\r\n}\r\n\r\ntag[type=\"theme\"] div {\r\n\tbackground-color: rgb(209, 189, 134) !important;\r\n}\r\n\r\ntag[source=\"auto-ai\"] i {\r\n\tcolor: rgb(255, 255, 0);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
